const app = angular.module('editor');

app.factory('$storage', ['$window', function ($window) {
    const field = 'editor:';
    return {
        set: function (key, value) {
            $window.localStorage[field + key] = value;
        },
        get: function (key, defaultValue) {
            return $window.localStorage[field + key] || defaultValue;
        },
        setObject: function (key, value) {
            $window.localStorage[field + key] = JSON.stringify(value);
        },
        getObject: function (key) {
            if (!$window.localStorage[field + key]) return null;
            return JSON.parse($window.localStorage[field + key]);
        },
        remove: function (key) {
            delete $window.localStorage[field + key];
        },
        clear: function () {
            $window.localStorage.clear();
        }
    };
}]);
